import { render, staticRenderFns } from "./CalendarSlots.vue?vue&type=template&id=15bd4732&"
import script from "./CalendarSlots.vue?vue&type=script&lang=js&"
export * from "./CalendarSlots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports